import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/VehicleTiles")
);

const ModelCategoryEditConfig = {
  emptyLabel: "ModelCategory",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = ({
  menuCategory,
  menuCategoryUrl,
  headerMenuItems = [],
} = {}) => ({
  category: menuCategory,
  models: headerMenuItems.map(
    ({
      menuName,
      menuSpecsLine1,
      menuSpecsLine2,
      menuImage,
      menuLink,
      ctas = [],
    }) => ({
      id: menuName,
      asset: menuImage,
      alt: menuName,
      title: menuName,
      copy: menuSpecsLine1,
      copy2: menuSpecsLine2,
      link: {
        href: menuLink,
      },
      ctas,
    })
  ),
});

const ModelCategory = (props) => {
  const data = transformData(props.headerMenuCategory);
  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/model-category")(
  ModelCategory,
  ModelCategoryEditConfig
);
